import { useOutletContext } from 'react-router-dom';
import UserManagement from '../components/adminDashboard/UserManagement';
import TierManagement from '../components/adminDashboard/TierManagement';
import AnalyticsManagement from '../components/adminDashboard/AnalyticsManagement';
import PaymentContent from '../components/adminDashboard/PaymentContent';
import TutorialManagement from '../components/adminDashboard/TutorialManagement';

const AdminDashboardPage = () => {
  const [activeSection] = useOutletContext();

  const renderContent = () => {
    switch(activeSection) {
      case 'analytics':
      case 'manage-users':
      case 'manage-tiers':
      case 'payments':
      case 'manage-tutorials':
        return (
          <div className="p-2 md:p-4">
            <div className="ml-6 p-2 md:p-4">
              <h2 className="txt-page-heading text-lg md:text-xl mb-4 md:mb-6">
                {activeSection.split('-').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </h2>
              {/* Component rendering based on section */}
              {activeSection === 'analytics' && <AnalyticsManagement />}
              {activeSection === 'manage-users' && <UserManagement />}
              {activeSection === 'payments' && <PaymentContent/>}
              {activeSection === 'manage-tiers' && <TierManagement />}
              {activeSection === 'manage-tutorials' && <TutorialManagement />}
            </div>
          </div>
        );

      default:
        return (
          <div className="p-2 md:p-4">
            <div className="rounded-xl p-4 md:p-6">
              <div className="text-center text-2xl text-bold text-btn-primary">
                Select a section from the sidebar
              </div>
            </div>
          </div>
        );
    }
  };

  return renderContent();
};

export default AdminDashboardPage;